export class DefaultService {

    currency: string = 'USD';

    language: string = 'en';

}